<template>
  <!-- List of your items -->
  <div v-if="newsToggle" id="news" :class="newsClass" class="pb-12">
    <div v-if="isNewsAvailable && !withNewscatcher" :class="newsClass + '__disclosure'">
      <a href="https://privacy.microsoft.com/en-US/privacystatement" target="_blank"
        >Content from Microsoft Start</a
      >
    </div>
    <div
      v-for="(News, index) in NewsItems"
      :key="index"
      :class="[
        {
          'partner-content': String(News).indexOf('AD') > -1,
        },
        newsClass + '__item',
      ]"
      class="rounded-md border-[1px] border-onelaunch_ui_shades_500 text-news_tile_color dark:border-border_header_summary dark:text-radio_group_text_color_dark"
    >
      <div
        v-if="String(News).indexOf('AD') > -1 || (index === 1 && isFiveTiles)"
        role="article"
        :aria-label="News?.Title ? `News Article: ${News?.Title}` : null"
        style="width: inherit; height: inherit"
      >
        <slot
          name="adsSlot"
          :position="index"
          :second-ad-tile="index === 1 && isFiveTiles"
          :widget-id="getOutbrainWidgetId(index)"
          :counter="String(News).substring(3)"
          :news="removedNewsItems[index]"
        />
      </div>
      <a
        v-else
        v-news-tile
        class="text-news_tile_color dark:text-radio_group_text_color_dark"
        :href="
          withNewscatcher ? `/summary?category=${News?.news_category}&aid=${News?.id}` : News?.TargetedUrl
        "
        :data-news-category="props.withNewscatcher ? News?.news_category : 'News'"
        :data-news-provider="News?.Provider"
        target="_blank"
        @click.prevent="
          props.withNewscatcher
            ? navigateToSummaryPage(News?.news_category, News?.id, {
                ntp_news_category: News?.news_category,
                ntp_news_provider: News?.Provider,
                ntp_tile_position: index,
              })
            : navigateToOriginalArticle(News?.TargetedUrl, {
                ntp_news_category: 'News',
                ntp_news_provider: News?.Provider,
                ntp_tile_position: index,
              })
        "
      >
        <div :class="newsClass + '__item-content'">
          <div
            :class="newsClass + '__item-image'"
            :style="`background-image: url('${News?.ThumbnailUrl}');`"
          />
          <div
            :class="newsClass + '__item-title'"
            class="text-news_tile_color dark:text-radio_group_text_color_dark"
          >
            <p>{{ News?.Title }}</p>
          </div>
        </div>
        <div :class="newsClass + '__item-provider text-end'">{{ News?.Provider }}</div>
      </a>
    </div>
    <ClassicNtpCommonWeather v-if="isNewsAvailable && !newDesign" />
    <div v-if="isNewsAvailable && newDesign" class="weather">
      <ClassicNtpCommonMsnWeather
        :tile-height="358"
        :icon-block-margin-top="50"
        :details-more-margin-top="40"
      />
    </div>
  </div>
</template>
<script setup>
  import $ from 'jquery'
  import { useDocumentVisibility } from '@vueuse/core'
  import { storeToRefs } from 'pinia'
  import { getTypeTag } from '~~/assets/js/utils'
  import { useNewsStore } from '~/store/NewsStore'
  import { useNewsStoreNewscatcher } from '~/store/NewsStoreNewscatcher'
  import { header } from '~~/store/header.js'
  import { useNewsToggleStore } from '~/store/NewsToggle'
  import { sendMixpanelEvent } from '~/utils/host-browser-apis'

  const newsClass = ref('news')
  const slots = useSlots()
  const activeTab = useDocumentVisibility()
  const hasSlot = () => {
    return !!slots.adsSlot
  }

  const props = defineProps({
    firstRowAdTilePosition: {
      type: Number,
      default: 0,
    },
    secondRowAdTilePosition: {
      type: Number,
      default: 0,
    },
    thirdRowAdTilePosition: {
      type: Number,
      default: 0,
    },
    adTilePositionIncrement: {
      type: Number,
      default: 0,
    },
    belowFoldAdTilePosition: {
      type: Number,
      default: 0,
    },
    newDesign: {
      type: Boolean,
      default: false,
    },
    withNewscatcher: {
      type: Boolean,
      default: false,
    },
    displayHeaderWithoutLogo: {
      type: Boolean,
      default: false,
    },
    isProgrammaticAdUnit: {
      type: Boolean,
      default: false,
    },
    hasBelowFoldAdUnit: {
      type: Boolean,
      default: false,
    },
  })

  const newsToggleStore = useNewsToggleStore()
  const { newsToggle } = storeToRefs(newsToggleStore)

  watch(newsToggle, (newValue, oldValue) => {
    if (oldValue === false && newValue === true) {
      $('#footer').css('position', 'fixed')
    }
  })

  const isFiveTiles = computed({
    get() {
      return window.innerWidth >= 1920
    },
  })

  function getOutbrainWidgetId(index) {
    if (isFiveTiles.value && index === 1) {
      return props.newDesign ? 'AR_12' : 'AR_6'
    } else if (
      (index === 4 && isFiveTiles.value) ||
      (!props.newDesign && index === 3) ||
      (props.newDesign && index === props.firstRowAdTilePosition)
    ) {
      return props.newDesign ? 'AR_13' : 'AR_1'
    } else if (index === props.secondRowAdTilePosition) {
      return props.newDesign ? 'AR_14' : 'AR_2'
    } else if (index === props.thirdRowAdTilePosition) {
      return props.newDesign ? 'AR_15' : 'AR_3'
    } else if (index === props.thirdRowAdTilePosition + props.adTilePositionIncrement) {
      return props.newDesign ? 'AR_16' : 'AR_4'
    } else {
      return props.newDesign ? 'AR_16' : 'AR_5'
    }
  }

  const NewsItems = ref([])
  let pageIndex = 0
  let updatingNews = false
  const NewsItemsStore = []
  let noMoreNews = false
  // there is  a bug at the moment in the wrangler 2 so cannot be tested locally but once that is resolved we will be able to test the functions locally
  // https://github.com/cloudflare/wrangler2/issues/1701

  let currentItems = 0
  let tileCount = 0
  let elementHeight = 0
  const tileHeight = 0
  let isThirdRowShown = false
  let shouldScroll = false
  const fixedClass = 'searchbox--fixed'
  let searchbox
  let threshold
  let reload = true
  const removedNewsItems = {}

  const route = useRoute()

  // weather tile was showing before the news, so show the weather once we have the data from the news api
  const isNewsAvailable = ref(false)
  let startIndex = 0
  onMounted(() => {
    if (props.newDesign) {
      newsClass.value = 'news-v5'
    }

    setTimeout(() => {
      try {
        if (activeTab.value === 'visible') {
          assignInitialTiles()
          props.withNewscatcher ? newscatcherInitialFetch() : initialFetch()
          reload = false
        }
      } catch {}

      document.addEventListener('scroll', handleScrollEvent)

      const interval = 10
      searchbox = document.querySelector('#searchbox')
      threshold = searchbox?.getBoundingClientRect()
      showRowOnPageLoad()
    }, 1000)
  })

  watch(activeTab, (current) => {
    if (current === 'visible' && reload) {
      try {
        if (activeTab.value === 'visible') {
          assignInitialTiles()
          props.withNewscatcher ? newscatcherInitialFetch() : initialFetch()
          reload = false
        }
      } catch {}
    }
  })

  function calculateTileSlotsForAvailableScreenState() {
    try {
      const newsItem = document?.querySelector('.news__item')

      const otherElements =
        newsItem?.parentNode?.parentNode?.querySelectorAll(':scope > div:not(#news)') || []
      const unavailableScreenSpace =
        [...otherElements]?.reduce((height, el) => height + el.offsetHeight, 0) || 0

      const screenHeight = window.innerHeight - unavailableScreenSpace
      const tileHeight = newsItem?.offsetHeight || 300
      const screenWidth = newsItem?.parentNode?.offsetWidth || window.innerWidth
      const tileWidth = newsItem?.offsetWidth || 330
      const additionalRowToAlwaysHaveScrollSpace = 1
      const availableRows = Math.floor(screenHeight / tileHeight) + additionalRowToAlwaysHaveScrollSpace
      const availableColumns = Math.floor(screenWidth / tileWidth)
      const availableTileSlots = availableRows * availableColumns

      return availableTileSlots
    } catch (e) {
      console.error(e)
      return 0
    }
  }

  function assignInitialTiles() {
    if (window.innerWidth >= 1920) {
      currentItems = 9
      tileCount = 10
    } else if (window.innerWidth > 1440) {
      currentItems = 7
      tileCount = 8
    } else if (window.innerWidth > 992 && window.innerWidth <= 1440) {
      currentItems = 7
      tileCount = 8
    } else if (window.innerWidth > 630 && window.innerWidth <= 992) {
      currentItems = 3
      tileCount = 4
    } else if (window.innerWidth <= 630) {
      currentItems = 3
      tileCount = 3
    }
  }

  function generateRandomString(len) {
    let randomString = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    for (let i = 0; i < len; i++) {
      randomString += characters.charAt(Math.floor(Math.random() * characters.length))
    }
    randomString = randomString.match(/.{1,4}/g).join('-')
    localStorage.setItem('activityID', randomString)
    return randomString
  }

  function initialFetch() {
    const activityID =
      localStorage?.getItem('activityID') != null
        ? localStorage?.getItem('activityID')
        : generateRandomString(16)
    startIndex = currentItems

    let news = null
    const newsStore = useNewsStore()
    const currentDate = new Date()
    const storeDate = new Date(newsStore.fetched_on)
    // We're subtracting UNIX timestamps, so divide by the number of milliseconds in an hour to get the difference in whole hours between the two dates.
    const difference = Math.floor((currentDate.getTime() - storeDate.getTime()) / (1000 * 60 * 60))
    const cachePeriod = 12
    // Check if newsStore has cached articles and the cache is within the valid period
    if (newsStore.articles != null && difference <= cachePeriod) {
      try {
        // Try to parse the stored articles from the cache
        const newsDataArray = JSON.parse(newsStore.articles)
        const handler = {}
        const newsProxy = new Proxy(newsDataArray, handler)
        buildNews(newsProxy)
      } catch {
        // Clear the cache if parsing the stored articles fails
        newsStore.fetched_on = null
        newsStore.articles = null
        const { data: NewsArticlesData } = useLazyFetch(
          '/api/news/200' + '/' + pageIndex + '/' + activityID,
          { initialCache: false }
        )
        news = NewsArticlesData
      }
    } else {
      try {
        // Fetch new articles if there are no cached articles or the cache has expired
        const { data: NewsArticlesData } = useLazyFetch(
          '/api/news/200' + '/' + pageIndex + '/' + activityID,
          { initialCache: false }
        )
        news = NewsArticlesData
      } catch {
        if (newsStore.articles != null) {
          try {
            // Try to parse the stored articles from the cache
            const newsDataArray = JSON.parse(newsStore.articles)
            const handler = {}
            const newsProxy = new Proxy(newsDataArray, handler)
            buildNews(newsProxy)
          } catch {
            // Clear the cache if parsing the stored articles fails
            newsStore.fetched_on = null
            newsStore.articles = null
            const { data: NewsArticlesData } = useLazyFetch(
              '/api/news/200' + '/' + pageIndex + '/' + activityID,
              { initialCache: false }
            )
            news = NewsArticlesData
          }
        }
      }
    }

    watch(news, (NewsArticles) => {
      buildNews(NewsArticles)
      if (typeof NewsArticles === 'object' && NewsArticles.length > 0) {
        // Cache the fetched articles and store the fetch timestamp
        newsStore.fetched_on = currentDate
        newsStore.articles = JSON.stringify(NewsArticles)
      }
      //! Pagination is removed for now as the api is not retuning data on subsequent api calls on scroll
      // pageIndex++
    })
  }

  let position

  if (process.client) {
    position = $(window).scrollTop()
  }

  function handleScrollEvent() {
    // reference for update request
    let searchboxUpdating = false

    const handleScroll = () => {
      if (threshold === undefined) {
        searchbox = document.querySelector('#searchbox')
        threshold = searchbox?.getBoundingClientRect()
      }
      if (window.scrollY > threshold.top || window.pageYOffset > threshold.top) {
        searchbox.classList.add(fixedClass)
      } else {
        searchbox.classList.remove(fixedClass)
      }
      searchboxUpdating = false
    }

    // TODO: we cannot have multiple onscroll events for each components so we should move this to the parent and base component
    window.onscroll = async () => {
      if (!shouldScroll) {
        return
      }

      let showFooter = true
      if (!isThirdRowShown && NewsItemsStore?.length > 0) {
        showRowOnPageLoad(isInViewport(document.querySelector('.weather-tile')))
      }

      if (searchboxUpdating) {
        return
      } else {
        searchboxUpdating = true
        window.requestAnimationFrame(handleScroll)
      }

      if (
        window.innerHeight + window.scrollY >= document.body.scrollHeight * 0.95 &&
        !updatingNews &&
        !noMoreNews
      ) {
        updatingNews = true

        const endIndex = startIndex + tileCount

        addToNewsItems(startIndex, endIndex)
        await sendMixpanelEvent('NtpMoreNews_Loaded')

        if (endIndex > NewsItemsStore?.length) {
          noMoreNews = true
        }

        //! Pagination is removed for now as the api is not retuning data on subsequent api calls on scroll
        // if (NewsItemsStore.length < 210) {
        //   const url = '/api/news/' + (currentItems * 2) + '/' + pageIndex + '/' + activityID
        //   const { data } = await useFetch(url, { initialCache: false })

        //   filterNewsList(data?.value)

        //   if (hasSlot()) {
        //     addADLabelInList()
        //   }
        // showFooter = false
        // }
        showFooter = false

        startIndex = endIndex
        pageIndex++
        updatingNews = false
      }
      // hide show the footer
      const scroll = $(window).scrollTop()
      if (scroll < position && showFooter) {
        $('#footer').css('position', 'fixed')
      } else {
        $('#footer').css('position', 'absolute')
      }
      position = scroll
    }
  }

  function isInViewport(element) {
    if (typeof element === 'object' && element !== null && 'getBoundingClientRect' in element) {
      const rect = element.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom - (window.innerHeight || document.documentElement.clientHeight) <=
          (window.innerHeight || document.documentElement.clientHeight) / 2 &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }
  }

  function addToNewsItems(startIndex, endIndex) {
    if (NewsItemsStore?.length > 0) {
      const addNews = NewsItemsStore?.slice(startIndex, endIndex)
      addNews.forEach((element) => {
        NewsItems.value.push(element)
      })
    }
  }

  // Checks for blank white space by matching the window height with parent element height
  function isSpaceAvailable(elementHeight) {
    return window.innerHeight - elementHeight > 25
  }

  function fillAvailableSpaceWithTiles() {
    const availableTileSlots = calculateTileSlotsForAvailableScreenState()
    const itemsToBeAdded = availableTileSlots - startIndex >= 0 ? availableTileSlots - startIndex : 0
    const endIndex = startIndex + itemsToBeAdded

    addToNewsItems(startIndex, endIndex)
    startIndex = endIndex
  }

  window.addEventListener('resize', () => fillAvailableSpaceWithTiles())

  // Shows row on page load if space is available
  function showRowOnPageLoad(showThirdRow) {
    if (showThirdRow === undefined) {
      fillAvailableSpaceWithTiles(showThirdRow)
      return
    }

    const showRow = isSpaceAvailable(elementHeight)
    if (showRow || showThirdRow) {
      let thirdRowTilesCount
      if (window.innerWidth >= 1920) {
        thirdRowTilesCount = 4
      } else if (window.innerWidth > 992) {
        thirdRowTilesCount = isThirdRowShown ? 4 : 3
      } else if (window.innerWidth <= 992) {
        thirdRowTilesCount = isThirdRowShown ? 4 : 1
      }

      const endIndex = startIndex + thirdRowTilesCount
      addToNewsItems(startIndex, endIndex)
      startIndex = endIndex
      elementHeight = elementHeight + tileHeight
      isThirdRowShown = true
      if (!showThirdRow && isSpaceAvailable(elementHeight)) {
        showRowOnPageLoad()
      }
    }
  }

  function filterNewsList(NewsArticles) {
    if (typeof NewsArticles === 'object' && NewsArticles?.length > 0) {
      let NewsItemsList = null
      if (props.withNewscatcher) {
        NewsItemsList = NewsArticles?.filter(
          (x) =>
            x.ThumbnailUrl !== undefined &&
            x.Provider !== undefined &&
            x.Title !== undefined &&
            x.TargetedUrl !== undefined &&
            x.news_category !== undefined
        )
        NewsItemsList.forEach(function (obj) {
          obj.news_category = 'News'
        })
      } else {
        NewsItemsList = NewsArticles?.filter(
          (x) =>
            x.ThumbnailUrl !== undefined &&
            x.Provider !== undefined &&
            x.Title !== undefined &&
            x.TargetedUrl !== undefined
        )
      }
      NewsItemsStore.push(...NewsItemsList)
    }
  }

  function buildNews(NewsArticles) {
    filterNewsList(NewsArticles)
    if (NewsItemsStore?.length > 0) {
      shouldScroll = true
      isNewsAvailable.value = true
    }
    if (hasSlot() && NewsItemsStore?.length > 0) {
      if (props.withNewscatcher && props.isProgrammaticAdUnit) {
        removedNewsItems[props.firstRowAdTilePosition] = NewsItemsStore?.splice(
          props.firstRowAdTilePosition,
          1,
          'AD-1'
        )[0]
      } else {
        NewsItemsStore?.splice(props.firstRowAdTilePosition, 0, 'AD-1')
      }
      NewsItemsStore?.splice(props.secondRowAdTilePosition, 0, 'AD-2')
      if (props.thirdRowAdTilePosition !== 0) {
        NewsItemsStore?.splice(props.thirdRowAdTilePosition, 0, 'AD-3')
      }
      addADLabelInList()
      addBelowFoldAdLabel()
    }

    addToNewsItems(0, currentItems)
  }

  function addBelowFoldAdLabel() {
    if (props.withNewscatcher && props.hasBelowFoldAdUnit) {
      NewsItemsStore?.splice(props.belowFoldAdTilePosition, 1, 'AD-BELOW-FOLD')
    }
  }

  function addADLabelInList() {
    const list = NewsItemsStore?.filter((item) => String(item).includes('AD'))
    let counter = String(list[list.length - 1]).substring(3)
    const index = NewsItemsStore?.indexOf('AD-' + counter)
    for (let i = index; i < NewsItemsStore?.length; i = i + props.adTilePositionIncrement) {
      if (i + props.adTilePositionIncrement <= NewsItemsStore.length) {
        counter++
        NewsItemsStore?.splice(i + props.adTilePositionIncrement, 0, 'AD-' + counter)
      }
    }
  }

  function newscatcherInitialFetch() {
    startIndex = currentItems
    let news = null
    const newsStore = useNewsStoreNewscatcher()
    const currentDate = new Date()
    const storeDate = new Date(newsStore.News_fetched_on)
    // We're subtracting UNIX timestamps, so divide by the number of milliseconds in an hour to get the difference in whole hours between the two dates.
    const difference = Math.floor((currentDate.getTime() - storeDate.getTime()) / (1000 * 60 * 60))
    const cachePeriod = 12
    // Check if newsStore has cached articles and the cache is within the valid period
    if (newsStore.News != null && difference <= cachePeriod) {
      try {
        // Try to parse the stored articles from the cache
        const newsDataArray = JSON.parse(newsStore.News)
        const handler = {}
        const newsProxy = new Proxy(newsDataArray, handler)
        buildNews(newsProxy)
      } catch {
        // Clear the cache if parsing the stored articles fails
        newsStore.News_fetched_on = null
        newsStore.News = null
        const { data: NewsArticlesData } = useLazyFetch('/api/newscatcher', {
          params: {
            category: 'News',
          },
          initialCache: false,
        })
        news = NewsArticlesData
      }
    } else {
      try {
        // Fetch new articles if there are no cached articles or the cache has expired
        const { data: NewsArticlesData } = useLazyFetch('/api/newscatcher', {
          params: {
            category: 'News',
          },
          initialCache: false,
        })
        news = NewsArticlesData
      } catch {
        if (newsStore.News != null) {
          try {
            // Try to parse the stored articles from the cache
            const newsDataArray = JSON.parse(newsStore.News)
            const handler = {}
            const newsProxy = new Proxy(newsDataArray, handler)
            buildNews(newsProxy)
          } catch {
            // Clear the cache if parsing the stored articles fails
            newsStore.News_fetched_on = null
            newsStore.News = null
            const { data: NewsArticlesData } = useLazyFetch('/api/newscatcher', {
              params: {
                category: 'News',
              },
              initialCache: false,
            })
            news = NewsArticlesData
          }
        }
      }
    }
    watch(news, (NewsArticles) => {
      buildNews(NewsArticles)
      if (typeof NewsArticles === 'object' && NewsArticles.length > 0) {
        // Cache the fetched articles and store the fetch timestamp
        newsStore.News_fetched_on = currentDate
        newsStore.News = JSON.stringify(NewsArticles)
      }
      //! Pagination is removed for now as the api is not retuning data on subsequent api calls on scroll
      // pageIndex++
    })
  }

  async function navigateToOriginalArticle(TargetedUrl, eventData) {
    await sendMixpanelEvent('NtpNewsTile_Clicked', eventData)
    window.open(TargetedUrl, '_blank')
  }

  async function navigateToSummaryPage(category, articleId, eventData) {
    await sendMixpanelEvent('NtpNewsTile_Clicked', eventData)
    const adProvider = route.query.native
    let summaryPageLink = `/summary?category=${category}&aid=${articleId}`
    if (adProvider && props.withNewscatcher) {
      summaryPageLink += `&native=${adProvider}`
    }
    const type = getTypeTag()
    if (type && props.withNewscatcher) {
      summaryPageLink += `&type=${type}`
    }
    if (header.isNewHeader && props.displayHeaderWithoutLogo) {
      summaryPageLink += '&headerWithoutLogo=true'
    }
    window.open(summaryPageLink, '_blank')
  }

  const vNewsTile = {
    mounted: async (element) => {
      await sendMixpanelEvent('NtpNewsTile_Rendered', {
        ntp_news_category: element.dataset.newsCategory,
        ntp_news_provider: element.dataset.newsProvider,
      })
    },
  }
</script>
<style lang="scss" scoped>
  .news {
    display: grid;
    gap: 24px;
    margin: auto;
    max-width: 1272px;
    width: fit-content;
    margin-top: 16px;

    &__disclosure {
      position: absolute;
      margin-top: -27px;

      a {
        color: #a0a0a0;
        font-size: 12px;
        font-style: italic;
      }
    }

    &__item {
      display: block;
      height: 374px;
      text-align: left;
      max-width: 300px;
      cursor: pointer;
    }

    &__item-image {
      background-position: center center;
      background-size: cover;
      height: 250px;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      animation: opacity-0-to-1-fade-in 1s;
    }

    &__item-content {
      height: 346px;

      &:hover {
        text-decoration: underline;
      }
    }

    &__item-title {
      margin: 12px 12px auto;
      max-width: 276px;
      font-size: 16px;
      line-height: 1.43;

      & > p {
        -webkit-line-clamp: 3;
        display: -webkit-box; // stylelint-disable-line  value-no-vendor-prefix
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    &__item-provider {
      margin-bottom: 12px;
      margin-right: 12px;
      font-size: 12px;
      line-height: 1.33;
    }
  }

  .news-v5 {
    display: grid;
    gap: 24px;
    margin: auto;
    max-width: 1272px;
    width: 100%;
    margin-top: 16px;

    &__disclosure {
      position: absolute;
      margin-top: -27px;

      a {
        color: #a0a0a0;
        font-size: 12px;
        font-style: italic;
      }
    }

    &__item {
      border-radius: 6px;
      display: block;
      height: 358px;
      text-align: left;
      width: 300px;
      cursor: pointer;
    }

    &__item-image {
      background-position: center center;
      background-size: cover;
      height: 250px;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      animation: opacity-0-to-1-fade-in 1s;
    }

    &__item-content {
      height: 334px;

      &:hover {
        text-decoration: underline;
      }
    }

    &__item-title {
      margin: 12px 12px auto;
      max-width: 268px;
      height: 60px;
      font-size: 16px;
      line-height: 1.43;

      & > p {
        -webkit-line-clamp: 3;
        display: -webkit-box; // stylelint-disable-line  value-no-vendor-prefix
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }

    &__item-provider {
      margin-bottom: 12px;
      margin-right: 12px;
      font-size: 12px;
      line-height: 1.33;
      color: #757575;
    }
  }

  .weather {
    width: 300px;
    height: 358px;
  }

  @media (min-width: 1440px) {
    .news {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (max-width: 1680px) {
    .news {
      max-width: 912px;

      &__item {
        max-width: 210px;
        height: 261px;
      }

      &__item-image {
        height: 175px;
      }

      &__item-content {
        height: 242px;
      }

      &__item-title {
        max-width: 193px;
        font-size: 14px;

        & > p {
          -webkit-line-clamp: 2;
        }
      }
    }
  }

  @media (min-width: 993px) and (max-width: 1440px) {
    .news {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (max-width: 1920px) {
    .news-v5 {
      grid-template-columns: repeat(4, 1fr);
    }

    .weather {
      grid-row: 2;
      grid-column: 4;
    }
  }

  @media (max-width: 1350px) {
    .news-v5 {
      grid-template-columns: repeat(3, 1fr);
      width: 948px;
    }

    .weather {
      grid-row: 2;
      grid-column: 3;
    }
  }

  @media (max-width: 980px) {
    .news-v5 {
      grid-template-columns: repeat(2, 1fr);
      max-width: 624px;
    }

    .weather {
      grid-row: 2;
      grid-column: 2;
    }
  }

  @media (max-width: 630px) {
    .news-v5 {
      grid-template-columns: repeat(1, 1fr);
      max-width: 300px;
    }

    .weather {
      grid-row: 2;
      grid-column: 1;
    }
  }

  @media (min-width: 631px) and (max-width: 992px) {
    .news {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 630px) {
    .news {
      grid-template-columns: repeat(1, 1fr);
    }
  }

  @media (min-width: 1920px) {
    .news {
      max-width: 1572px;
      grid-template-columns: repeat(5, 1fr);
    }

    .news-v5 {
      max-width: 1596px;
      grid-template-columns: repeat(5, 1fr);
    }

    .weather {
      grid-row: 2;
      grid-column: 5;
    }
  }

  @keyframes opacity-0-to-1-fade-in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
</style>
